import { View } from "binder"
import { DateEditorViewModel } from "./dateEditor-viewModel"

export class DateEditorView extends View<DateEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-4902E328-D6B0-491A-B68B-3018F16AEC71"
    }
    loadHtml(): string {
        let element = require('./dateEditor.html').default;
        let style = require('./dateEditor.less');
        return element;
    }
    constructor() {
       super();
    }
}
